<template>
    <Header />
    <template class="grid">
        <Sub_ManageUsers></Sub_ManageUsers>
        <Gestion></Gestion>
    </template>
</template>

<script setup>
import Gestion from '@/apps/GestionRoles/views/Gestion.vue';
import Sub_ManageUsers from './Sub_ManageUsers.vue';
import Header from '@/components/Header.vue';

</script>

<style lang="scss" scoped>
    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(720px, 900px));
        // grid-template-rows: minmax(90vh, 100%);
        grid-auto-rows: auto;
        gap: 1rem;

        justify-content: center;
    }
</style>